"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billingRequest = billingRequest;
exports.billingXMLGetRequest = billingXMLGetRequest;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * запрос в биллинг
 * @param {string} billingHost Хост биллинга нужного города (из консоли)
 * @param {string} procedure Точка входа (например, 'es_webface/web_cabinet.get_info')
 * @param {JSON} params Параметры запроса
 * @returns {Promise}
 */
function billingRequest(billingHost, procedure, params) {
  var url = "".concat(billingHost, "/cgi-bin/ppo/") + procedure;
  return _axios["default"].get(url, {
    params: params
  });
}
/**
 * get-запрос в биллинг для авторизованного пользователя
 * @param {string} billingHost Хост биллинга нужного города (из консоли)
 * @param {string} accessToken Токен авторизации из биллинга
 * @param {string} procedure Точка входа (например, 'es_webface/web_cabinet.get_info')
 * @param {string} request Параметр запроса (params)
 * @param {Object} additionalParams Дополнительные параметры запроса в виде ключ-значение
 * @param {Object} jsonConfig настройки для конвертации в json
 * @returns {Promise}
 */


function billingXMLGetRequest(_x, _x2, _x3, _x4) {
  return _billingXMLGetRequest.apply(this, arguments);
}

function _billingXMLGetRequest() {
  _billingXMLGetRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(billingHost, accessToken, procedure, request) {
    var additionalParams,
        jsonConfig,
        _yield$import,
        X2JS,
        params,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            additionalParams = _args.length > 4 && _args[4] !== undefined ? _args[4] : {};
            jsonConfig = _args.length > 5 ? _args[5] : undefined;
            _context.next = 4;
            return Promise.resolve().then(function () {
              return _interopRequireWildcard(require('x2js'));
            });

          case 4:
            _yield$import = _context.sent;
            X2JS = _yield$import["default"];
            params = {
              params: request,
              access_token: accessToken
            };

            if (additionalParams) {
              params.param_names_arr$c = Object.keys(additionalParams).join(',');
              params.param_values_arr$c = Object.values(additionalParams).join(',');
            }

            return _context.abrupt("return", billingRequest(billingHost, procedure, params).then(function (response) {
              var x2js = new X2JS(jsonConfig);
              var data = x2js.xml2js(response.data).data;
              return {
                status: data.status,
                errorCode: data.messages.code,
                errorMessage: data.messages.text,
                data: data.result
              };
            }));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _billingXMLGetRequest.apply(this, arguments);
}